export const translations = {
	'Data Source': {},
	'Datasource grid': {
		no: 'Datakilde tabell',
	},
	'Show values in thousands': {
		no: 'Vis verdier i tusen',
	},
	'Datasource': {},
	'Name': {},
	'X axis': {},
	'Columns': {},
	'All columns': {},
	'Filters': {},
	'Script parameters': {},
	'General': {},
	'Sort and limit': {},
	'Key': {},
	'Value': {},
	'Add parameter': {},
	'A parameter above has this key, this one is ignored': {},
	'Delete': {},
	'Expand': {},
	'Collapse': {},
	'Rows': {},
	'Columns from': {},
	'Values': {},
	'All number columns': {},
	'Pivot': {},
	'Split values': {},
	'Invert': {},
	'Edit': {},
	'Apply': {},
	'Every row': {},
	'Pick a datasource to build the filter of its columns': {},
	'Time': {},
	'Column': {},
	'Period': {},
	"Without a time column the datasource's own period applies": {},
	'Sort by': {},
	'Limit': {},
	'All rows': {},
	'Descending': {},
	'Table': {},
	'Line': {},
	'Bar': {},
	'Gauge': {},
	'Preview': {},
};
